var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeganIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.5,
    height: 66.5,
    viewBox: "0 0 66.5 66.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1-vegan,.cls-2-vegan{fill:none;stroke:#e5b515;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px}.cls-1-vegan{stroke-linejoin:round}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vegan",
    transform: "translate(-76.5 -382.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    d: "M117.154 402.651a12.426 12.426 0 0 0-19.812 3.058c-.155.3-19.112 33.956-19.112 33.956a1.384 1.384 0 0 0 1.15 2.125 1.338 1.338 0 0 0 .745-.229s33.675-18.943 33.971-19.1a12.426 12.426 0 0 0 3.058-19.812z",
    className: "cls-1-vegan",
    transform: "translate(0 5.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    d: "M129.706 384c0 1.379.2 9.466-5.522 15.184S109 404.707 109 404.707s-.2-9.467 5.522-15.185S128.325 384 129.706 384z",
    className: "cls-1-vegan",
    transform: "translate(11.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    d: "M127.184 405.141s-3.4 4.141-7.592 4.141-7.592-4.141-7.592-4.141 3.4-4.141 7.591-4.141 7.593 4.141 7.593 4.141z",
    className: "cls-1-vegan",
    transform: "translate(12.935 6.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_109",
    d: "M0 0L8.283 8.283",
    className: "cls-2-vegan",
    transform: "translate(98.705 410.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_110",
    d: "M0 0L6.902 6.902",
    className: "cls-2-vegan",
    transform: "translate(93.184 418.528)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeganIcon);
export default __webpack_public_path__ + "static/media/vegan-icon.b863e371.svg";
export { ForwardRef as ReactComponent };